<template>
    <div class="pricing-area pt-100 pb-70 bg-f4f6fc">
        <div class="container">
            <div class="section-header" data-aos="fade-up">
                <span class="section-tag">Faire Preise</span>
                <h2>So kommen wir zusammen</h2>
                <p>Jedes Projekt ist einzigartig - deshalb gibt es bei uns keine Pauschalpreise. Nach einem kostenlosen Erstgespräch erhalten Sie ein individuelles Angebot, das genau auf Ihre Anforderungen zugeschnitten ist.</p>
            </div>

            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6 col-sm-6" data-aos="fade-right" data-aos-delay="0">
                    <div class="single-pricing-box">
                        <div class="pricing-header">
                            <div class="icon">
                                <i class='bx bx-message-dots'></i>
                            </div>
                            <h3>1. Anfrage</h3>
                        </div>
                        <p class="pricing-desc">Erzählen Sie mir von Ihrem Projekt. Per E-Mail, Telefon oder Kontaktformular - wie es Ihnen am liebsten ist.</p>
                        <ul class="pricing-features">
                            <li><i class='bx bxs-badge-check'></i> Unverbindliche Kontaktaufnahme</li>
                            <li><i class='bx bxs-badge-check'></i> Erste Projektbeschreibung</li>
                            <li><i class='bx bxs-badge-check'></i> Schnelle Rückmeldung</li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-delay="100">
                    <div class="single-pricing-box active">
                        <div class="pricing-header">
                            <div class="icon">
                                <i class='bx bx-conversation'></i>
                            </div>
                            <h3>2. Beratung</h3>
                        </div>
                        <p class="pricing-desc">In einem kostenlosen Erstgespräch besprechen wir Ihre Anforderungen, Ziele und Wünsche im Detail.</p>
                        <ul class="pricing-features">
                            <li><i class='bx bxs-badge-check'></i> Kostenlose Erstberatung</li>
                            <li><i class='bx bxs-badge-check'></i> Persönlicher Austausch</li>
                            <li><i class='bx bxs-badge-check'></i> Ehrliche Einschätzung</li>
                        </ul>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-6" data-aos="fade-left" data-aos-delay="200">
                    <div class="single-pricing-box">
                        <div class="pricing-header">
                            <div class="icon">
                                <i class='bx bx-file'></i>
                            </div>
                            <h3>3. Angebot</h3>
                        </div>
                        <p class="pricing-desc">Sie erhalten ein detailliertes Angebot mit transparenten Kosten. Keine versteckten Gebühren, keine Überraschungen.</p>
                        <ul class="pricing-features">
                            <li><i class='bx bxs-badge-check'></i> Detaillierte Aufstellung</li>
                            <li><i class='bx bxs-badge-check'></i> Die besten Preise am Markt</li>
                            <li><i class='bx bxs-badge-check'></i> Keine Verpflichtung</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="text-center mt-5">
                <router-link to="/contact" class="btn-benovium">
                    <i class='bx bxs-paper-plane'></i>
                    Kostenloses Erstgespräch vereinbaren
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IndividuelleAngebote'
}
</script>

<style scoped>
.single-pricing-box {
    background: #ffffff;
    border-radius: 5px;
    padding: 35px;
    margin-bottom: 30px;
    transition: all 0.3s ease;
    box-shadow: 0 0 20px rgba(0,0,0,0.05);
}

.single-pricing-box:hover,
.single-pricing-box.active {
    transform: translateY(-10px);
    box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.pricing-header {
    text-align: center;
    margin-bottom: 25px;
}

.pricing-header .icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #010215 0%, #010215 100%);
    margin: 0 auto 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.pricing-header .icon i {
    font-size: 40px;
    color: #ffffff;
    line-height: 1;
}

.pricing-header h3 {
    font-size: 22px;
    font-weight: 700;
    margin: 0;
}

.pricing-desc {
    text-align: center;
    color: #666;
    margin-bottom: 25px;
    min-height: 72px;
}

.pricing-features {
    list-style: none;
    padding: 0;
    margin: 0;
}

.pricing-features li {
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    color: #555;
}

.pricing-features li:last-child {
    border-bottom: none;
}

.pricing-features li i {
    color: #080a3c;
    margin-right: 8px;
}
</style>
